import {action} from 'typesafe-actions';
import {UserRole} from '@models/user-role';
import {Resources} from "@models/resources";
import {RequestData} from "@models/axios";

export const enum UserRolesActionTypes {
    FETCH_REQUEST = '@@UserRoles/FETCH_REQUEST',
    FETCH_SUCCESS = '@@UserRoles/FETCH_SUCCESS',
    FETCH_ERROR = '@@UserRoles/FETCH_ERROR',

    DELETE_REQUEST = '@@UserRoles/DELETE_REQUEST',
    DELETE_SUCCESS = '@@UserRoles/DELETE_SUCCESS',
    DELETE_ERROR = '@@UserRoles/DELETE_ERROR',

    CREATE_REQUEST = '@@UserRoles/CREATE_REQUEST',
    CREATE_SUCCESS = '@@UserRoles/CREATE_SUCCESS',
    CREATE_ERROR = '@@UserRoles/CREATE_ERROR',

    UPDATE_REQUEST = '@@UserRoles/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@UserRoles/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@UserRoles/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = '@@UserRoles/FETCH_ITEM_REQUEST',
    FETCH_ITEM_SUCCESS = '@@UserRoles/FETCH_ITEM_SUCCESS',
    FETCH_ITEM_ERROR = '@@UserRoles/FETCH_ITEM_ERROR',

    ASSIGN_RESOURCES_REQUEST = '@@UserRoles/ASSIGN_RESOURCES_REQUEST',
    ASSIGN_RESOURCES_SUCCESS = '@@UserRoles/ASSIGN_RESOURCES_SUCCESS',
    ASSIGN_RESOURCES_ERROR = '@@Resources/ASSIGN_RESOURCES_ERROR',

    DELETE_RESOURCES_REQUEST = '@@UserRoles/DELETE_RESOURCES_REQUEST',
    DELETE_RESOURCES_SUCCESS = '@@UserRoles/DELETE_RESOURCES_SUCCESS',
    DELETE_RESOURCES_ERROR = '@@UserRoles/DELETE_RESOURCES_ERROR'

}


export const fetchRequest = (data: RequestData) => action(UserRolesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: UserRole[]) => action(UserRolesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(UserRolesActionTypes.FETCH_ERROR, message);


export const deleteRequest = (data: RequestData) => action(UserRolesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data: RequestData) => action(UserRolesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(UserRolesActionTypes.DELETE_ERROR, message);


export const createRequest = (data: RequestData) => action(UserRolesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: UserRole[]) => action(UserRolesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(UserRolesActionTypes.CREATE_ERROR, message);


export const updateRequest = (data: RequestData) => action(UserRolesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: UserRole[]) => action(UserRolesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(UserRolesActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data: RequestData) => action(UserRolesActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: UserRole[]) => action(UserRolesActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(UserRolesActionTypes.FETCH_ITEM_ERROR, message);

export const assignResourcesRequest = (data: RequestData) => action(UserRolesActionTypes.ASSIGN_RESOURCES_REQUEST, data);
export const assignResourcesSuccess = (data: Resources[]) => action(UserRolesActionTypes.ASSIGN_RESOURCES_SUCCESS, data);
export const assignResourcesError = (message: string) => action(UserRolesActionTypes.ASSIGN_RESOURCES_ERROR, message);

export const deleteResourcesRequest = (data: RequestData) => action(UserRolesActionTypes.DELETE_RESOURCES_REQUEST, data);
export const deleteResourcesSuccess = (data: RequestData) => action(UserRolesActionTypes.DELETE_RESOURCES_SUCCESS, data);
export const deleteResourcesError = (message: string) => action(UserRolesActionTypes.DELETE_RESOURCES_ERROR, message);
